import React from "react";

import "../styles/redistricting-dashboard-homepage.css";

const HomepageAnnouncement = () => (
  <div className="redistricting-dashboard-homepage">
    <a
      className="report-card-announcement"
      href="/2026-congressional-plan-analysis"
    >
      <span className="report-card-announcement__eyebrow">
        New announcement
      </span>
      <h2>
        Princeton Gerrymandering Project Completes Analysis of Congressional
        Plans for 2026
      </h2>
      <span className="report-card-announcement__cta">
        Read the full announcement
      </span>
    </a>
  </div>
);

export default HomepageAnnouncement;
